<div class="busy-snackbar">
  <span>{{ message }}</span>
  <button mat-icon-button (click)="dismiss()" [attr.aria-label]="'DIALOGS.CLOSE' | translate">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</div>
